import React from 'react';
import Icon from '../Icon/Icon';
import Box from '../Box/Box';

import TEFeedbackSignal from '../../types/TEFeedbackSignal';

type TInlineFeedbackIcon = {
  icon: string;
  signal: TEFeedbackSignal;
};

const InlineFeedbackIcon = ({ icon, signal }: TInlineFeedbackIcon) => (
  <Box as="div" parent="InlineFeedback" name="icon">
    <Icon name={icon} color={signal} />
  </Box>
);

export default InlineFeedbackIcon;
